// extracted by mini-css-extract-plugin
export default {"tooltip":"_slVnlY_beEUPwXzMyay","tooltipArrow":"DpO0dvw_KCDHoMQPTQ6v","arrow":"ArGpd4cLJpyB2IzUpCHn","text":"gc7Twz_kmiHeguperRiF"};